import { DialogConfirmComponent } from './../../dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { ArmazemService } from './../../../service/endereco/armazem.service';
import { ArmazemModel } from './../../../model/endereco/armazem.model';
import { MatIconRegistry } from '@angular/material/icon';
import { ResponsePageable } from './../../../model/cliente/pageable/responsePageable.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModuloService } from './../../../service/endereco/modulo.service';
import { ModuloModel } from './../../../model/endereco/modulo.model';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.scss']
})
export class ModuloComponent implements OnInit {

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public modulo = {} as ModuloModel;
  public modulos: ModuloModel[];
  public submit = false;
  @ViewChild('cardEdit') targetEl: ElementRef;
  public formModulo: FormGroup;
  public page: ResponsePageable;
  public pageAtual = 0;
  public loading = true;

  user: any;
  creatorModulo = false;
  editorModulo = false;
  listaModulo = false;
  deletaModulo = false;
  superUser = false;
  arrayString: string;
  armazems: ArmazemModel[];

  constructor(private _snackBar: MatSnackBar,
    private armazemService: ArmazemService,
    iconRegistry: MatIconRegistry,
    private dialog: MatDialog,
    private moduloService: ModuloService,
    sanitizer: DomSanitizer,
    private fb: FormBuilder) {
      iconRegistry.addSvgIcon('question', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/question-circle.svg'));
     }

  ngOnInit() {
    //this.listarModulos();
    this.listPageModulo(0,10);
    this.getAuthority();

    // Formulário de módulo
    this.formModulo = this.fb.group({
      id: [null],
      nome: [null, [Validators.maxLength(100), Validators.required]],
      armazem: [null, Validators.required],
      ativo: [null],
      tipo: [null, Validators.required],
      altura: [null, Validators.required],
      largura: [null, [Validators.maxLength(100)]],
      ordenacao: [null, Validators.required],
      profundidade: [null,  Validators.required],
      capacidadeHorizontal: [null, Validators.required],
      capacidadeVertical: [null, Validators.required],
      paridade: [null]
    });
  }

  addOrEdit() {
    if (this.modulo.id != null) {
      this.editarModuloFunction();
    } else {
      this.adicionarModulo();
    }
  }

  adicionarModulo() {
    this.loading = true;
    if (this.formModulo.valid) {
      let ativo = this.formModulo.get('ativo').value;
      let paridade = this.formModulo.get('paridade').value;
      if (ativo !== true) {
        this.formModulo.get('ativo').setValue(false);
      }
      if (paridade != true) {
        this.formModulo.get('paridade').setValue(false);
      }
      this.moduloService.adicionarModulo(this.formModulo.value).subscribe(data => {
          console.log(data);
          this.openSnackBarSuccess(`Módulo ${data.nome} salvo com sucesso !`);
          this.listPageModulo(0, 10);
          this.submit = false;
          this.formModulo.reset();
      }, err => {
        console.error(err);
        this.openSnackBarError('Erro ! ' + err.error.message);
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }
  }

  editarModuloFunction() {
    this.loading = true;
    this.moduloService.editarModulo(this.modulo).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess(`Módulo ${data.nome} editado com sucesso !`);
      this.listPageModulo(this.pageAtual, 10);
      this.submit = false;
      this.formModulo.reset();
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Erro ao tentar editar o módulo !');

    });
  }

  apagarModuloDialog(moduloId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este módulo ?', from: 'modulo.component.ts'}
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarModulo(moduloId);
      }
    });
  }

  apagarModulo(moduloId: number) {
    this.moduloService.deleteModulo(moduloId).subscribe(() => {
      this.openSnackBarSuccess('Módulo excluído com sucesso !');
      this.listarModulos();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar excluír o módulo !');
    });
  }

  limpar() {
    this.submit = false;
  }

  listarModulos() {
    this.moduloService.getModulos().subscribe(data => {
      console.log(data);
      this.modulos = data.content;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  listPageModulo(page, size) {
    this.moduloService.getPageModulo(page, size).subscribe(res => {
      this.loading = false;
      this.page = res;
      this.modulos = this.page.content;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro na listagem !');
      this.loading = false;
    });
  }

  editarModulo(modulo: ModuloModel) {
    this.modulo = { ...modulo};
  }

  //Mudar paginação
  changePage(event) {
    this.listPageModulo(event.page, event.size);
    this.pageAtual = event.page;
   }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  onSubmit() {
    this.submit = true;
  }

  getArmazem() {
    this.armazemService.getArmazem().subscribe(data => {
      this.armazems = data.content;
    });
  }

  compararArmazem(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorModulo = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorModulo = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaModulo = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaModulo = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/modulo/modulo.component.ts